const PIXEL_ID = '2711181339263183'
let initialized = false

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

function loadPixelScript() {
  if (initialized) return
  initialized = true

  const f = window as any
  const n = (f.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  }) as any
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const first = document.getElementsByTagName('script')[0]
  if (first && first.parentNode) {
    first.parentNode.insertBefore(script, first)
  } else {
    document.head.appendChild(script)
  }

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  loadPixelScript()
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  loadPixelScript()
  window.fbq('track', 'AddToCart', {
    content_name: 'Protocolo Post-Crisis P.A.E.',
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  })
}
